import { ComponentsPropsList } from '@mui/material'
import { Theme } from '@mui/material/styles'

import MuiAccordion from './accordion'
import MuiAutocomplete from './autocomplete'
import MuiAvatar from './avatars'
import MuiBackdrop from './backdrop'
import MuiBreadcrumb from './breadcrumbs'
import MuiButton from './button'
import MuiButtonGroup from './buttonGroup'
import MuiCard from './card'
import MuiChip from './chip'
import MuiDataGrid from './dataGrid'
import MuiDatepicker from './datepicker'
import MuiDialog from './dialog'
import MuiDivider from './divider'
import MuiFab from './fab'
import MuiInput from './input'
import MuiLink from './link'
import MuiList from './list'
import MuiMenu from './menu'
import MuiPagination from './pagination'
import MuiPaper from './paper'
import MuiPopover from './popover'
import Progress from './progress'
import MuiRating from './rating'
import MuiSelect from './select'
import MuiSnackbar from './snackbar'
import MuiSwitches from './switches'
import MuiTable from './table'
import MuiTabs from './tabs'
import MuiTimeline from './timeline'
import MuiToggleButton from './toggleButton'
import MuiTypography from './typography'

export type OwnerStateThemeType = {
  theme: Theme
  ownerState: ComponentsPropsList[keyof ComponentsPropsList] & Record<string, unknown>
}

const Overrides = () => {
  const fab = MuiFab()
  const chip = MuiChip()
  const list = MuiList()
  const tabs = MuiTabs()
  const input = MuiInput()
  const tables = MuiTable()
  const menu = MuiMenu()
  const button = MuiButton()
  const rating = MuiRating()
  const select = MuiSelect()
  const cards = MuiCard()
  const avatars = MuiAvatar()
  const progress = Progress()
  const divider = MuiDivider()
  const dialog = MuiDialog()
  const backdrop = MuiBackdrop()
  const dataGrid = MuiDataGrid()
  const datePicker = MuiDatepicker()
  const switches = MuiSwitches()
  const timeline = MuiTimeline()
  const popover = MuiPopover()
  const accordion = MuiAccordion()
  const snackbar = MuiSnackbar()
  const pagination = MuiPagination()
  const autocomplete = MuiAutocomplete()

  return Object.assign(
    fab,
    chip,
    list,
    menu,
    tabs,
    cards,
    input,
    select,
    button,
    dialog,
    rating,
    tables,
    avatars,
    divider,
    popover,
    MuiLink,
    backdrop,
    datePicker,
    dataGrid,
    MuiPaper,
    progress,
    snackbar,
    switches,
    timeline,
    accordion,
    pagination,
    autocomplete,
    MuiTypography,
    MuiBreadcrumb,
    MuiButtonGroup,
    MuiToggleButton
  )
}

export default Overrides
